import React from "react"
import { store } from "store"
import { useSelector } from "react-redux"
import { DragDropContext, Droppable } from "@hello-pangea/dnd"
import { orderedColumns, reorderColumns } from "reduxSlices/taskTableSlice"
import Column from "./Column"

const ColumnList = () => {
  const columns = useSelector(orderedColumns)

  const changeColumns = ({ source, destination }) => store.dispatch(
    reorderColumns({
      startIndex: source.index,
      endIndex: destination.index,
    }),
  )

  return (
    <DragDropContext onDragEnd={changeColumns}>
      <Droppable droppableId="droppable">
        {
          (dropProvided) => (
            <div ref={dropProvided.innerRef} {...dropProvided.droppableProps}>
              {
                columns.map(({ label, value }, index) => (
                  <Column
                    key={value}
                    label={label}
                    value={value}
                    index={index}
                  />
                ))
              }
              { dropProvided.placeholder }
            </div>
          )
        }
      </Droppable>
    </DragDropContext>
  )
}

export default ColumnList
